/**
 * The coral "Critical" word beside a battery at 15% or less (Eric, 2026-11-04: "15% or less is
 * critical"). Only when the server's live_status says critical_low (contract §5). It uses the
 * theme's coral token (src/styles/globals.css): #E0556C in dark mode, a darker coral in light
 * mode so the small text stays readable (review on #1197).
 */
import { cn } from '@/lib/utils';

const CORAL = [
  'text-[color:var(--live-coral)]',
  'border-[color:color-mix(in_srgb,var(--live-coral)_30%,transparent)]',
  'bg-[color:color-mix(in_srgb,var(--live-coral)_15%,transparent)]',
].join(' ');

export function BatteryCriticalTag({ show, className }: { show: boolean; className?: string }) {
  if (!show) return null;
  return (
    <span className={cn('inline-flex flex-shrink-0 items-center rounded border px-1 text-[10px] font-medium leading-4', CORAL, className)}>
      Critical
    </span>
  );
}
